/* Cold-plunge / chiller PDP shared controller (window.PlungePDP). Cross-section utilities so each
   editable cp-* section can rely on one stars/reveal/scroll (and an optional cart) implementation
   without a single ancestor wrapper. The buy-box is the native main-product section, so addToCart
   here is only for any non-buy-box CTA. Loaded once; deduped by URL across sections. Ported from
   assets/sauna-pdp.js (window.SaunaPDP). */
(function () {
  if (window.PlungePDP) return;

  // ---------- add to cart (AJAX + drawer + section re-render) — for non-buy-box CTAs only ----------
  var adding = false;
  function setLoading(btn, on) { if (!btn) return; btn.classList.toggle('is-loading', on); btn.disabled = on; }
  function flashDone(btn) {
    if (!btn) return;
    var l = btn.querySelector('.btn-label');
    if (l) { btn.setAttribute('data-prev', l.innerHTML); l.textContent = 'Added to cart ✓'; }
    btn.classList.add('is-done');
    setTimeout(function () { btn.classList.remove('is-done'); var ll = btn.querySelector('.btn-label'); if (ll && btn.getAttribute('data-prev')) ll.innerHTML = btn.getAttribute('data-prev'); }, 2200);
  }
  function updateCartCount(n) {
    document.querySelectorAll('cart-count').forEach(function (c) { c.textContent = n; c.setAttribute('aria-label', n + ' items'); if (n > 0) c.removeAttribute('hidden'); });
  }
  function injectSections(sectionsObj) {
    if (!sectionsObj) return;
    Object.keys(sectionsObj).forEach(function (id) {
      var html = sectionsObj[id];
      if (!html) return;
      var target = document.getElementById('MiniCart-' + id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.getElementById('MiniCart-' + id);
      if (src) target.innerHTML = src.innerHTML;
    });
  }
  // opts: { form } to post an existing <form>, OR { variantId, quantity, sellingPlan } for a
  // self-built payload. { button } is the element to spin.
  function addToCart(opts) {
    opts = opts || {};
    var btn = opts.button;
    if (adding) return;
    var fd;
    if (opts.form) {
      fd = new FormData(opts.form);
    } else if (opts.variantId) {
      fd = new FormData();
      fd.append('id', opts.variantId);
      fd.append('quantity', opts.quantity || 1);
      if (opts.sellingPlan) fd.append('selling_plan', opts.sellingPlan);
    } else {
      return;
    }
    adding = true; setLoading(btn, true);
    var drawer = document.querySelector('cart-drawer');
    var sections = [];
    document.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    var dsid = drawer && drawer.getAttribute('data-section-id');
    if (dsid && sections.indexOf(dsid) === -1) sections.push(dsid);
    if (sections.length) { fd.append('sections', sections.join(',')); fd.append('sections_url', window.location.pathname); }
    if (drawer && typeof drawer.show === 'function') { drawer.classList.add('cp-adding'); drawer.show(); }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (data) {
        injectSections(data.sections);
        if (drawer) drawer.classList.remove('cp-adding');
        setLoading(btn, false); flashDone(btn); adding = false;
        if (!drawer) document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { open: true } }));
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { updateCartCount(c.item_count); }).catch(function () {});
      })
      .catch(function () { if (drawer) drawer.classList.remove('cp-adding'); setLoading(btn, false); adding = false; if (opts.form) opts.form.submit(); });
  }

  // ---------- star rendering ----------
  function starSvg() {
    return '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l2.9 6.1 6.6.9-4.8 4.7 1.2 6.6L12 18.2 6.1 20.3l1.2-6.6L2.5 9l6.6-.9z"/></svg>';
  }
  function renderStars(root) {
    (root || document).querySelectorAll('[data-stars]').forEach(function (el) {
      if (el.getAttribute('data-stars-done')) return;
      var n = parseInt(el.getAttribute('data-stars'), 10) || 5;
      el.innerHTML = Array.from({ length: n }, starSvg).join('');
      el.setAttribute('data-stars-done', '1');
    });
  }

  // ---------- scroll reveal (progressive; never permanently hides content) ----------
  var REVEAL_SEL = '.section-head, .cp-grid, .cp-cards, .cp-card, .cp-table, .cp-rev-grid, .cp-modes-grid, .cp-roi-grid, .cp-compare-grid, .cp-contact-inner, .cp-support-inner';
  function initReveal(root, opts) {
    root = root || document;
    opts = opts || {};
    // Reveal targets = the structural selectors PLUS any element that hardcodes .cp-reveal in Liquid
    // (.cp-logos-row, .cp-inbox-grid, .cp-roi-payoff, .cp-spec-wrap, .cp-support-cta, .cp-region-row).
    // Without the .cp-reveal catch-all those are hidden by CSS but never observed, so they stay
    // invisible forever.
    var els = [].slice.call(root.querySelectorAll((opts.selector || REVEAL_SEL) + ', .cp-reveal'));
    if (!els.length) return;
    els.forEach(function (el) { el.classList.add('cp-reveal'); });
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var inEditor = window.Shopify && window.Shopify.designMode;
    // When the scroll observer can't be trusted (theme editor iframe, reduced motion, no IO support),
    // reveal immediately so content is NEVER left hidden.
    if (reduce || inEditor || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cp-in'); });
      return;
    }
    var rObs = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('cp-in'); rObs.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { rObs.observe(el); });
    // Safety net: never leave anything hidden, even if the observer never fires.
    setTimeout(function () { els.forEach(function (el) { el.classList.add('cp-in'); }); }, 2500);
  }

  // ---------- smooth scroll for in-page [data-scroll] anchors (document-wide, once) ----------
  var smoothInit = false;
  function initSmoothScroll() {
    if (smoothInit) return; smoothInit = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.cp-pdp [data-scroll]');
      if (!link) return;
      var id = (link.getAttribute('href') || '').replace('#', '');
      var target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
    });
  }

  window.PlungePDP = {
    addToCart: addToCart,
    renderStars: renderStars,
    initReveal: initReveal,
    initSmoothScroll: initSmoothScroll
  };
})();
